import type { CreditAccountType } from "@/types/profile";
import { ChangePhoneNumberModalEnum } from "@/types/profile";
import { create } from "zustand";
import type { ChangePhoneNumberFormReturn } from "./forms/useChangePhoneNumberForm";
import type { CreditAccountTransaction } from "@/__generated__/graphql";

type ProfileState = {
  changePhoneNumberModalOpen: boolean;
  changeNumberOtpVerificationModalOpen: boolean;
  cancelChangePhoneNumber: boolean;
  changeNumberSuccessModal: boolean;
  creditTopUpModalOpen: boolean;
  changePhoneNumberFormReturn: ChangePhoneNumberFormReturn | null;
  phone: string;
  updatedPhone: string;
  pinCode: string;
  creditAccountType: CreditAccountType;
};

export type CreditAccountData = {
  title: string;
  balance: string;
  transaction: CreditAccountTransaction;
};

export const useProfileState = create<{
  data: ProfileState;
  setChangePhoneNumberReturn: (
    data: ChangePhoneNumberFormReturn | null,
  ) => void;
  setPhone: (phone: string) => void;
  setUpdatedPhone: (phone: string) => void;
  setPinCode: (pinCode: string) => void;
  showModal: (...modalNames: ChangePhoneNumberModalEnum[]) => void;
  setCreditAccountType: (CreditAccountTransaction: CreditAccountType) => void;
  setCreditTopUpModal: (creditTopUpModalOpen: boolean) => void;
}>((set, get) => ({
  data: {
    phone: "",
    updatedPhone: "",
    pinCode: "",
    changePhoneNumberModalOpen: false,
    changeNumberOtpVerificationModalOpen: false,
    cancelChangePhoneNumber: false,
    changeNumberSuccessModal: false,
    creditTopUpModalOpen: false,
    changePhoneNumberFormReturn: null,
    creditAccountData: null,
    creditAccountType: "general",
  },
  setChangePhoneNumberReturn: (
    changePhoneNumberFormReturn: ChangePhoneNumberFormReturn | null,
  ) => {
    set({ data: { ...get().data, changePhoneNumberFormReturn } });
  },
  setPhone: (phone: string) => {
    set({ data: { ...get().data, phone } });
  },
  setUpdatedPhone: (updatedPhone: string) => {
    set({ data: { ...get().data, updatedPhone } });
  },
  setPinCode: (pinCode: string) => {
    set({ data: { ...get().data, pinCode } });
  },
  setCreditAccountType: (creditAccountType: CreditAccountType) => {
    set({ data: { ...get().data, creditAccountType } });
  },
  setCreditTopUpModal: (creditTopUpModalOpen: boolean) => {
    set({ data: { ...get().data, creditTopUpModalOpen } });
  },
  showModal: (...modalNames: (ChangePhoneNumberModalEnum | null)[]) => {
    set({
      data: {
        ...get().data,
        changePhoneNumberModalOpen: modalNames.includes(
          ChangePhoneNumberModalEnum.CHANGE_PHONE_NUMBER,
        ),
        changeNumberOtpVerificationModalOpen: modalNames.includes(
          ChangePhoneNumberModalEnum.CHANGE_PHONE_NUMBER_OTP_VERIFICATION,
        ),
        cancelChangePhoneNumber: modalNames.includes(
          ChangePhoneNumberModalEnum.CANCEL_CHANGE_PHONE_NUMBER,
        ),
        changeNumberSuccessModal: modalNames.includes(
          ChangePhoneNumberModalEnum.CHANGE_PHONE_NUMBER_SUCCESS,
        ),
      },
    });
  },
}));
